import { Banner, Divider, Spinner, Stack } from '@customerio/pluma-components/react';
import { GoogleAuthButton } from '@/components/sso-sign-in-button';
import type { GoogleSignupState } from './use-google-one-click-signup';

type GoogleSignupPanelProps = {
  state: GoogleSignupState;
  onClick: () => void;
};

/**
 * The Google half of the entry step: the button, the wait, and the
 * incomplete-name outcome where the visitor finishes with the form below.
 * The spinner and the banner are mutually exclusive by construction.
 */
export function GoogleSignupPanel({ state, onClick }: GoogleSignupPanelProps) {
  return (
    <>
      <Stack alignInline="center" gap="400" mb="300">
        <GoogleAuthButton
          type="signup"
          // Once an identity is bound the address is fixed, so a second run
          // would only be able to contradict it.
          isDisabled={state !== 'idle'}
          onClick={onClick}
          data-testid="signup-google-one-click"
        />
        {state === 'running' ? <Spinner shouldShowLoadingText label="Waiting for Google auth…" /> : null}
        {state === 'succeeded' ? (
          <Banner variant="success" title="Google sign-up successful" description="Your Google account is connected." />
        ) : null}
      </Stack>
      <Divider label="or" />
    </>
  );
}
